import {
  PrimaryButton,
  PrimaryButtonProps,
} from '@/app/components/PrimaryButton/PrimaryButton'
import CheckCircleIcon from '@/app/icons/CheckCircleIcon/CheckCircleIcon'
import { useEnquiriesExperience } from '@/app/providers/Enquiries'
import { EnquiryContext, EnquiryFeature } from '@/types/enquiry'
import { useTranslations } from 'next-intl'

export type FeatureRequestButtonProps = Omit<
  PrimaryButtonProps,
  'children' | 'href'
> & {
  featureRequest: EnquiryFeature
  context: EnquiryContext
  children?: React.ReactNode
}

export function FeatureRequestButton({
  featureRequest,
  context,
  children,
  ...props
}: FeatureRequestButtonProps) {
  const t = useTranslations('Enquiries')
  const { isLoading, isEnquiryRequested, sendEnquiry, isDisabled } =
    useEnquiriesExperience()

  return isEnquiryRequested(featureRequest, context) ? (
    <PrimaryButton
      {...props}
      type="button"
      className={`!text-[--text] ${props.small ? '!rounded-lg !px-3 !py-2 !text-xs' : ''} ${props.className ?? ''}`}
      disabled
      isLoading={isLoading}
    >
      <div className="flex items-center gap-1">
        {t('request-sent')}
        <CheckCircleIcon
          className={`ml-auto ${props.small ? 'h-3 w-3' : 'h-4 w-4'}`}
        />
      </div>
    </PrimaryButton>
  ) : (
    <PrimaryButton
      {...props}
      disabled={isDisabled}
      type="button"
      isLoading={isLoading}
      className={`${props.small ? '!rounded-lg !px-3 !py-2 !text-xs' : ''} ${props.className ?? ''}`}
      onClick={(e) => {
        e.preventDefault()
        sendEnquiry({ featureRequest, context })
      }}
    >
      {children ? children : t('activate-option')}
    </PrimaryButton>
  )
}
